// PublicProfile
import { trendSWRFetch } from 'api';
import Icon from 'components/common/Icon';
import Loader from 'components/common/Loader';
import React from 'react';
import { trackEvent } from 'services/analytics';
import useSWR from 'swr';
import { PublicProfileResponse } from 'types/profile';
import About from '../Profile/About';
import Portfolio from './Portfolio';
import Rating from 'components/common/Rating';
import styles from './PublicProfile.module.sass';
import Header from './Header';

export interface PublicProfileProps {
  id: string;
}

const PublicProfile: React.FC<PublicProfileProps> = ({ id }) => {
  const { data: creatorProfile } = useSWR<PublicProfileResponse>(
    `/creator/profile/public/${encodeURIComponent(id)}`,
    trendSWRFetch
  );

  const trackCTAClick = (location: 'header' | 'footer bar') => {
    trackEvent('Visitor Clicks Find Me on Trend Button', {
      profileId: id,
      buttonLocation: location,
      profileType: 'public',
      copy: 'Work with Me',
    });
  };

  return (
    <div className={styles.publicProfile}>
      <Header
        showNavBar
        isLoading={typeof creatorProfile === 'undefined'}
        trackCTAClick={trackCTAClick}
        creatorId={creatorProfile?.creatorId}
        profilePicture={creatorProfile?.profilePicture}
        firstName={creatorProfile?.firstName}
        lastName={creatorProfile?.lastName}
        overallRating={creatorProfile?.overallRating}
      />
      <div className={styles.contentSection}>
        <div className={styles.trendCard}>
          <h6>What is Trend?</h6>
          <p>
            We've made it simple for you to find and collaborate with the
            country's most talented photo and video makers at a set rate. We've
            had over 10,000 creator applications but have limited our network to
            the top 5% of all applications.
          </p>
          <p>Welcome to the new world of content creation.</p>
        </div>
        {typeof creatorProfile !== 'undefined' ? (
          <div className={styles.profileContent}>
            <Portfolio
              creatorId={creatorProfile.creatorId}
              profileType="public"
              profilePicture={creatorProfile.profilePicture!}
              portfolio={creatorProfile.portfolio}
              creatorName={`${creatorProfile.firstName} ${creatorProfile.lastName}`}
            />
            <About
              profileType="public"
              about={creatorProfile.about}
              socials={creatorProfile.socials}
              socialCategories={creatorProfile.socialCategories}
              contentCategories={creatorProfile.contentCategories}
              environment={creatorProfile.environment}
              equipment={creatorProfile.equipment}
            />
          </div>
        ) : (
          <div className={styles.contentLoading}>
            <Loader />
          </div>
        )}
      </div>
      <div className={styles.bottomBar}>
        <div className={styles.barContent}>
          <div className={styles.availability}>
            <span className={styles.shieldContainer}>
              <Icon name="verified-shield" size={32} color="neutral00" />
            </span>
            <div className={styles.availabilityText}>
              <p>Current availability:</p>
              <p>Ready for hire</p>
            </div>
          </div>
          <div className={styles.actionContainer}>
            <Rating
              rating={creatorProfile?.overallRating}
              className={styles.rating}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicProfile;
